<template>
  <DModal :show-close="false"
          :isBgOverlay="true"
          @close="close">
    <template slot="insertComponent">
      <div class="add-lesson__header" :style="{'backgroundColor': color ? color : '#2c81ba'}">
        <h2>Opret fag i {{ theCreateSubject.klassebetegnelse }}</h2>
        <div class="font-large icon__bg-circle d-modal__header__close" @click="close"><span
          class="icon-cross2"></span>
        </div>
      </div>
      <div class="add-lesson__form">
        <div class="input-group">
          <label>Titel*</label>
          <input type="text" v-model="title" ref="inputTitle">
        </div>
        <div class="input-group">
          <label>Fagkode*</label>
          <select v-model="fagkode">
            <option
              v-for="fag in standardSubjects"
              :key="fag.fagkode"
              :value="fag.fagkode">
              {{ fag.fagkode }}: {{ fag.name }}
            </option>
          </select>
        </div>
        <div class="input-group">
          <label>Klassetimer på året*</label>
          <input type="text" v-model="klokketimer" @focus="$event.target.select()">
        </div>
      </div>
      <div class="input-group input-group__submit">
        <div class="input-group__submit__left">
        </div>
        <div class="input-group__submit__right">
          <button class="marg-1-right bg-white" @click="close">{{ $t('vue2.common.cancel') }}</button>
          <div v-if="!isFormValid" class="hint--top-left" aria-label="Udfyld formularen">
            <button class="submit-button submit-button--disabled">Opret</button>
          </div>
          <button v-else class="submit-button" @click="submit">Opret</button>
        </div>
      </div>
    </template>
  </DModal>
</template>

<script>
import {mixin as clickaway} from 'vue-clickaway'
import DModal from '../../common/DModal'
import DSelect from '../../DSelect/DSelect'

export default {
  components: {DSelect, DModal},
  mixins: [clickaway],
  props: {
    standardSubjects: {
      type: Array,
      default: () => []
    },
    theCreateSubject: {
      type: Object,
      default: () => {
      }
    }
  },
  data () {
    return {
      title: '',
      fagkode: 110,
      klokketimer: 220
    }
  },
  computed: {
    schoolId () {
      return this.$route.params.school_id
    },
    users () {
      return this.$store.getters.usersSortedOnName
    },
    isFormValid () {
      return this.title.length > 0 && this.isValidNumber(this.klokketimer)
    }
  },
  methods: {
    isValidNumber (input) {
      if (input.length < 1) {
        return false
      }
      if (isNaN(input)) {
        return false
      }
      if (input < 0) {
        return false
      }
      return true
    },
    close () {
      this.$emit('close')
    },
    submit () {
      const fag = {
        klasse_id: this.theCreateSubject.klasse_id,
        fag_id: new Date().valueOf(),
        fag_navn: this.title,
        fagkode: this.fagkode,
        klokketimer: this.klokketimer,
        laerere: []
      }
      this.$emit('save', fag)
      this.$emit('close')
    }
  },
  mounted () {
    this.$nextTick(_ => {
      this.$refs.inputTitle.focus()
    })
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";

.add-lesson__form .d-table tbody tr td {
  width: auto !important;
}

.add-lesson__form .d-table tbody tr:nth-child(odd) {
  background: #fff;
}

input[type="number"] {
  max-width: 65px;
  padding: 0.5rem 0.75rem;
  text-align: center;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

select,
input[type="text"] {
  height: 36px;
  background-color: #ffffff;
  border-radius: 4px;
  min-width: 100px;
  box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgb(0 0 0 / 0.05);
  border: 1px solid #d8d8d8;
}

.d-table input[type="text"] {
  max-width: 40px;
}

.add-lesson__header {
  position: relative;
  transition: background-color 0.4s;
  padding: 30px 20px;
  color: #ffffff;
  border-radius: 4px 4px 0 0;
}

.add-lesson__header > h2 {
  color: white;
  margin-top: 0;
}

.add-lesson__form {
  position: relative;
  padding: 1rem 2rem;
  overflow-y: scroll;
  width: 450px;
  max-height: calc(100vh - 10vh - 120px); /* 120px is modal header; 10vh is modal from vtop */
}

.input-group {
  margin-top: 1rem;
}

.input-group label {
  margin-bottom: 0.5rem;
}

.input-group__submit {
  display: flex;
  justify-content: space-between;
  padding: 1rem 2rem;
}

.input-group input,
.input-group select {
  background-color: #fff;
  box-shadow: 0 2px 5px -1px rgb(50 50 93 / 25%), 0 1px 3px -1px rgb(0 0 0 / 30%);
  border: 1px solid #edf2f7;
  width: 100%;
}

.input-group input:focus {
  border: 1px solid var(--purple);
}

.input-group__submit__right {
  display: flex;
}

.input-group__submit__right button {
  box-shadow: 0 2px 5px -1px rgb(50 50 93 / 25%), 0 1px 3px -1px rgb(0 0 0 / 30%);
  border: 1px solid #edf2f7;
}

.input-group label {
  letter-spacing: .075rem;
  text-transform: uppercase;
  font-size: .85rem;
  line-height: 1rem;
  font-weight: 700;
  display: block;
  color: #a2a3a6;
  margin-bottom: 6px;
}

</style>



// WEBPACK FOOTER //
// KompetenceIndberetningKlasserFagForm.vue?327ba8a8